import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

type Props = {
  isDisabled?: boolean;
};

const styles = (props: Props) =>
  makeStyles<Theme>((theme) => ({
    mainDiv: {
      width: "135px",
      height: "135px",
      backgroundColor: "#FFFFFF",
      position: "relative",
      marginRight: "15px",
      marginBottom: "15px",
      [theme.breakpoints.down("lg")]: {
        marginRight: 0,
      },
    },
    file: {
      top: "calc(50% - 63px/2 + 3px)",
      left: "calc(50% - 44px/2)",
      width: "44px",
      minWidth: "44px",
      border: "1px solid #93A9BD",
      height: "57px",
      position: "absolute",
      background: "#EDF5FB",
      boxSizing: "border-box",
      borderRadius: "4px",
      padding: 0,
    },
    iconDownload: {
      top: "calc(50% - 63px/2 + 3px)",
      left: "calc(50% - 44px/2)",
      position: "absolute",
    },
    textType: {
      position: "absolute",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 400,
      letterSpacing: "0em",
      textAlign: "center",
      color: "#465869",
      textTransform: "none",
      background: "#CCDEEE",
      borderRadius: "2px",
      width: "95%",
      height: "17px",
    },
    textDelete: {
      color: "#CF4842",
    },
    containerInput: {
      display: "flex",
      flexDirection: "row",
      position: "absolute",
      bottom: "-10px",
      marginBottom: "10px",
      justifyContent: "center",
      "& .input-form-content": {
        border: "none",
        borderBottom: props?.isDisabled ? "none" : "1px solid #000000",
      },
    },
    input: {
      width: "100%",
      "& .MuiInputBase-root": {
        background: "transparent",
      },
      "& input": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        fontSize: "12px",
        color: "#465869",
        lineHeight: "18px",
        textAlign: "center",
        border: "none",
        backgroundColor: "#FFFFFF !important",
        width: "100%",
        paddingTop: 0,
        marginTop: 10,
      },
      "& fieldset": {
        border: "none",
      },
    },
    iconButton: {
      position: "absolute",
      top: 0,
      right: 0,
      color: "#465869",
      marginTop: "5px",
      padding: 0,
      cursor: "pointer",
    },
  }));

export default styles;
